import React from 'react';

import { PoliceReportsDashboard } from '@/components/police-reports-dashboard';
import { useDocumentTitle } from '@/contexts/DocumentTitleContext';

export const PoliceReportsDashboardPage: React.FC = () => {
  const { setTitle } = useDocumentTitle();
  React.useEffect(() => {
    setTitle('Police Reports Dashboard');
  }, [setTitle]);

  return <PoliceReportsDashboard />;
};

export default PoliceReportsDashboardPage;
